"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("./constants");
var _Icon = require("../Icon");
var _constants2 = require("../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const namespace = 'frontino-form-control';
const TextField = exports.TextField = /*#__PURE__*/(0, _react.forwardRef)(({
  focus,
  onBlur,
  onFocus,
  onInput,
  onChange,
  value: externalValue,
  multiline,
  centered,
  disabled,
  modifier,
  className,
  maxLength,
  label,
  placeholder,
  messageShow,
  message,
  enableCountdown,
  readonly,
  id,
  name,
  rows,
  fullWidth,
  style,
  onClick,
  icon,
  type,
  prefix,
  format,
  InputComponent,
  children
}, forwardedRef) => {
  const [focused, setFocused] = (0, _react.useState)(false);
  const [value, setValue] = (0, _react.useState)(externalValue ?? '');
  const [countdown, setCountdown] = (0, _react.useState)(0);
  const inputRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(forwardedRef, () => inputRef.current);
  (0, _react.useEffect)(() => {
    setFocused(focus ?? false);
  }, [focus]);
  (0, _react.useEffect)(() => {
    focused && inputRef.current?.focus();
  }, [focused]);
  (0, _react.useEffect)(() => {
    setValue(externalValue ?? '');
  }, [externalValue]);
  const onBlurHandler = (0, _react.useCallback)(evt => {
    setFocused(false);
    onBlur && onBlur(evt);
  }, [onBlur]);
  const onFocusHandler = (0, _react.useCallback)(evt => {
    setFocused(true);
    onFocus && onFocus(evt);
  }, [onFocus]);
  const onInputHandler = (0, _react.useCallback)(() => {
    onInput && onInput(value);
  }, [enableCountdown, onInput]);
  const onChangeHandler = (0, _react.useCallback)(evt => {
    const value = evt.target.value ?? '';
    setValue(value);
    enableCountdown && setCountdown(value.length);
    onChange && onChange(evt);
  }, [onChange]);
  const isEmpty = (0, _react.useCallback)(value => {
    return !value && !(value || '').trim();
  }, []);
  const floated = focused || !isEmpty(externalValue) || value;
  let Field = (0, _react.useMemo)(() => multiline ? 'textarea' : 'input', [multiline]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: (0, _classnames.default)(`${namespace}--textfield ${namespace}--textbox`, namespace, className, focused && `${namespace}--focused`, multiline && `${namespace}--multiline`, centered && `${namespace}--centered`, disabled && `${namespace}--disabled`, floated && `${namespace}--floated`, fullWidth && `${namespace}--full-width`, modifier !== 'default' && `${namespace}--${modifier}`),
    onClick: onClick,
    style: style,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `${namespace}__control`,
      style: style,
      children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: `${namespace}__label`,
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `${namespace}__container` + (!fullWidth ? ` ${namespace}__container--max-with` : ""),
        children: [/*#__PURE__*/_react.default.createElement(InputComponent ?? Field, {
          className: `${namespace}__field` + (icon ? ` ${namespace}__field--with-icon` : ""),
          disabled,
          maxLength,
          value,
          readOnly: readonly,
          onBlur: onBlurHandler,
          onFocus: onFocusHandler,
          onInput: onInputHandler,
          onChange: onChangeHandler,
          placeholder: floated || !label ? placeholder : null,
          ref: inputRef,
          role: Field,
          id,
          name,
          rows,
          type,
          prefix,
          format
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("fieldset", {}), icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          className: "frontino-form-control__icon",
          size: _constants2.ComponentSize.SMALL,
          children: icon
        }), children]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: `${namespace}__border`
    }), messageShow && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: `${namespace}__message ${namespace}__message-fixed`,
      children: message
    })]
  });
});
TextField.frontinoName = 'FrontinoTextField';
TextField.defaultProps = {
  focus: false,
  className: '',
  enableCountdown: false,
  centered: false,
  value: undefined,
  placeholder: undefined,
  disabled: false,
  message: undefined,
  messageShow: true,
  label: undefined,
  maxLength: 120,
  onChange: null,
  multiline: false,
  onBlur: null,
  onFocus: null,
  modifier: _constants.ModifierType.DEFAULT,
  onInput: null,
  readonly: false,
  id: undefined,
  name: undefined,
  rows: 1,
  fullWidth: false,
  type: 'text',
  prefix: undefined,
  format: undefined
};